import { createFileRoute } from '@tanstack/react-router';
import { CampaignReviewPage } from '@/features/marketing';

/** Review & publish — `/marketing/campaigns/{id}/review` (its own page, not nested in the hub). */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/review')({
  component: CampaignReviewRoute,
});

function CampaignReviewRoute() {
  const { orgId, campaignId } = Route.useParams();
  return <CampaignReviewPage orgId={orgId} campaignId={campaignId} />;
}
